export interface StorageAdapter {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
}

const isStorageAvailable = (storage: Storage | null): boolean => {
  if (!storage) {
    return false
  }
  try {
    const testKey = '__random_key_we_are_not_going_to_use__'
    storage.setItem(testKey, testKey)
    const retrieved = storage.getItem(testKey)
    storage.removeItem(testKey)
    return retrieved === testKey
  } catch {
    return false
  }
}

const getStorage = (
  type: 'localStorage' | 'sessionStorage'
): Storage | null => {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return type === 'localStorage' ? window.localStorage : window.sessionStorage
  } catch {
    return null
  }
}

export const createStorageAdapter = (
  type: 'localStorage' | 'sessionStorage' = 'localStorage'
): StorageAdapter => {
  const storage = getStorage(type)

  return {
    getItem: (key: string): string | null => {
      if (!isStorageAvailable(storage)) {
        return null
      }
      try {
        return storage?.getItem(key) ?? null
      } catch {
        return null
      }
    },
    setItem: (key: string, value: string): void => {
      if (!isStorageAvailable(storage)) {
        return
      }
      try {
        storage?.setItem(key, value)
      } catch {
        void 0
      }
    },
  }
}

export const localStorageAdapter = createStorageAdapter('localStorage')
export const sessionStorageAdapter = createStorageAdapter('sessionStorage')
